'use strict';

var util = require('../../util/property-util');
var graphUtil = require('../../util/graph-util');
var messageDiscriptors = require('../../util/messageDiscriptors');

module.exports = /*@ngInject*/ ["HighChartFactory", "MessageDataFilter", "LocaleFactory", "TimeZoneFactory", function (HighChartFactory, MessageDataFilter, LocaleFactory, TimeZoneFactory) {
    var factory = {};

    factory.createAxes = function (chart, selectedProperties) {
        "use strict";
        selectedProperties.forEach(function (property) {
            var axisType = property.axis;
            var axis = graphUtil.findYAxis(chart.yAxis, axisType);
            var options = {
                'isMetric': LocaleFactory.isMetric()
            };
            var metaData = messageDiscriptors.getAxisMetaByType(axisType, options);

            if (!util.isDefined(axis)) {
                axis = HighChartFactory.createYAxis(metaData.type, metaData.color, metaData.unit, metaData.position, metaData.labelsEnabled, metaData.labelFunction);
                if (util.isDefined(axis)) {
                    chart.addAxis(axis, false, false, false);
                }
            } else {
                if (util.isDefined(metaData.unit) && (metaData.unit == "km/h" || metaData.unit == "mph")) {
                    axis.options.labels.myunit = metaData.unit;
                }
            }
        });
    };

    factory.createSeries = function (chart, messageName, selectedProperties, messageStructure, useGrouping, id) {
        "use strict";
        var seriesIds = [];
        selectedProperties.forEach(function (property) {
            var seriesId = generateSeriesId(messageName, messageStructure, property, id);
            seriesIds.push(seriesId);

            var isExistingSeries = util.isDefined(graphUtil.findSeries(chart.series, seriesId));

            if (!isExistingSeries) {
                var axisType = property.axis;
                var axis = chart.get(axisType);
                var options = {
                    'isMetric': LocaleFactory.isMetric()
                };
                var metaData = messageDiscriptors.getAxisMetaByType(axisType, options);
                if (util.isDefined(axis)) {
                    if (axis.options.labelsEnabled) {
                        axis.update(
                            {
                                labels: {
                                    enabled: true
                                }
                            }, false
                        );
                    }
                    var seriesObject = HighChartFactory.createSeries([], axis, seriesId, metaData.formatFunction, property);
                    seriesObject.dataGrouping = {
                        enabled: useGrouping
                    };
                    if (util.isDefined(seriesObject)) {
                        chart.addSeries(seriesObject, false, false);
                    }
                }
            } else {
                styleSeries(graphUtil.findSeries(chart.series, seriesId), property);
            }
        });
        return seriesIds;
    };

    var generateSeriesId = function (messageName, messageStructure, property, id) {
        "use strict";
        var serieId = property.label;
        var discriminator;
        if (messageStructure.hasDiscriminator(messageName)) {
            if (messageStructure.hasSubDiscriminator(messageName)) {
                discriminator = messageStructure.getDiscriminator(messageName, property.discriminatorName);
                serieId = discriminator.subDiscriminatorLabel + " " + property.subDiscriminatorName + " " + property.label;
            } else {
                discriminator = messageStructure.getDiscriminator(messageName, property.discriminatorName);
                serieId = discriminator.label + " " + property.label;
            }
        }
        if (util.isDefined(id)) {
            return id + " " + serieId;
        } else {
            return serieId;
        }
    };

    /**
     * Adds data to a highchart object
     * @param chart                                     The highchart object
     * @param {Array} data                              The data array that needs to be plotted
     * @param {String} messageName                      The message name that corresponds to the data
     * @param {Array} selectedProperties                A list of selected properties for this message/data
     * @param messageStructure                          The messageStructure (only used for getting sub-, dicriminator names etc,.. not used for the unique data in it)
     * @param {Function} createSeriesObjectFunction     Function that transforms a data entry to a highchart entry (must return [x,y] value)
     * @param {Function} shouldInsertNullValueFunction  This function returns an x value if the current x value is not close enough to the previous x value
     * @param {Boolean} replaceData                     True: replaces data already in the chart, False: adds datapoints to the chart (if series already exists)
     * @param {Number} id                               An extra id to add to the serie identifier (also shown in the chart legend)
     */
    factory.addDataToChart = function (chart, data, messageName, selectedProperties, messageStructure, createSeriesObjectFunction, shouldInsertNullValueFunction, replaceData, id, ignoreGaps) {
        "use strict";

        var dataMap = new Map();
        var interval = getInterval(data);
        selectedProperties.forEach(function (property) {
            var seriesId = generateSeriesId(messageName, messageStructure, property, id);
            dataMap.set(seriesId, {data: [], previousValue: undefined});
        });

        var timezoneOffset = TimeZoneFactory.getOffset();

        data.forEach(function (entry) {
            var entryProperties = MessageDataFilter.filterPropertiesForEntry(selectedProperties, entry, messageName, messageStructure);
            entryProperties.forEach(function (property) {
                var seriesId = generateSeriesId(messageName, messageStructure, property, id);
                var seriesMapObject = dataMap.get(seriesId);
                var chartObject = createSeriesObjectFunction(property, entry, timezoneOffset);

                if (util.isDefined(chartObject) && chartObject.length == 2) {

                    if (util.isDefined(seriesMapObject.previousValue) && !ignoreGaps) {
                        var insertNullxValue = shouldInsertNullValueFunction(chartObject[0], seriesMapObject.previousValue, interval);
                        if (util.isDefined(insertNullxValue)) {
                            seriesMapObject.data.push([insertNullxValue, null]);
                        }
                    }
                    seriesMapObject.data.push(chartObject);
                    seriesMapObject.previousValue = chartObject[0];
                }
            });
        });
        selectedProperties.forEach(function (property) {
            var seriesId = generateSeriesId(messageName, messageStructure, property, id);
            var series = graphUtil.findSeries(chart.series, seriesId);
            var mapObject = dataMap.get(seriesId);
            if (replaceData || !util.isDefined(series.size) || series.size == 0) {
                series.setData(mapObject.data, false, false, true);
                series.size = mapObject.data.length;
            } else {

                mapObject.data.forEach(function (point) {
                    series.addPoint(point, false, false);
                });
                series.size += mapObject.data.length;
            }
        });
    };

    factory.cleanupSeries = function (chart, seriesIds) {
        "use strict";
        var seriesToDelete = [];
        chart.series.forEach(function (series) {
            if (seriesIds.indexOf(series.name) == -1 && series.name != "Navigator") {
                if (graphUtil.countYAxisUsage(chart.series, series.options.yAxis) == 1) {
                    chart.yAxis[series.options.yAxis].update(
                        {
                            labels: {
                                enabled: false
                            }
                        }, false
                    );
                }
                seriesToDelete.push(series);
            }
        });
        seriesToDelete.forEach(function (series) {
            series.remove();
        })
    };

    factory.getSeriesIdsForSelectedProperties = function (messageName, messageStructure, selectedProperties, id) {
        "use strict";
        var seriesIds = [];
        selectedProperties.forEach(function (property) {
            seriesIds.push(generateSeriesId(messageName, messageStructure, property, id));
        });

        return seriesIds
    };

    function styleSeries(series, property) {
        "use strict";
        var size = series.size;
        if (util.isDefined(series)) {
            if (util.isDefined(property.color)) {
                series.update({color: property.color}, false);
            }

            if (util.isDefined(property.bullet)) {
                series.update({marker: {symbol: property.bullet}}, false);
            }

            if (util.isDefined(property.dashStyle)) {
                series.update({dashStyle: property.dashStyle}, false);
            }

            // add the index to the series
            // the index determines the order in which the series/graphs are stacked
            if (util.isDefined(property.index)){
                series.update({index: property.index}, false);
            }
        }
        series.size = size;
    }

    function getInterval(dataSet, timestampPropertyName) {
        if (!util.isDefined(timestampPropertyName)) {
            timestampPropertyName = "timestamp";
        }
        if (dataSet.length > 1) {
            var dateFormat = !!angular.isDate(dataSet[0][timestampPropertyName]);
            var intervalArray = [];
            for (var index = 0; index < dataSet.length; index++) {
                if (index + 1 < dataSet.length) {
                    var interval = 0;
                    if (dateFormat) {
                        interval = dataSet[index + 1][timestampPropertyName].getTime() / 1000 - dataSet[index][timestampPropertyName].getTime() / 1000;
                    } else {
                        interval = (dataSet[index + 1][timestampPropertyName] / 1000) - (dataSet[index][timestampPropertyName] / 1000);
                    }
                    interval = Math.round(interval);
                    if (interval != 0) {
                        intervalArray.push(interval);
                    }
                }
            }
            return mode(intervalArray);
        } else {
            return 1;
        }
    }

    function mode(array) {
        if (array.length == 0)
            return null;
        var modeMap = {};
        var maxEl = array[0], maxCount = 1;
        for (var i = 0; i < array.length; i++) {
            var el = array[i];
            if (modeMap[el] == null)
                modeMap[el] = 1;
            else
                modeMap[el]++;
            if (modeMap[el] > maxCount) {
                maxEl = el;
                maxCount = modeMap[el];
            }
        }
        return maxEl;
    }

    return factory;
}];